/**
 * !!! IMPORTANT !!!
 *    Istnieje dokładna kopia tego pliku w folderze otp -> otp-representative-page -> src -> pages -> AffiliatePage.
 *    Dokonując zmian w tym pliku oraz w pliku ./hooks -> useAffiliatePageLogic.tsx należy te same zmiany 
 *    skopiować do projektu otp-representative-page do bliźniaczych plików. 
 * !!! IMPORTANT !!!
*/
import { ILoanInitLimits } from '../../service/LoanInitService'
import { AppDispatch } from '../../store'
import { SET_CURRENT_SELECTED_PREDEFINED_PERIOD, SET_IS_PREDEFINED_PERIODS_AVAILABLE } from '../../store/actions/application-actions'
import {PREDEFINED_PERIODS_OFFER_LOGIC, SliderStep} from "../../store/types";




/**
 * Enum z nazwami partnerów afiliacyjnych
 */
export enum affiliatePartnersNames {
   Adtraction ="Adtraction", // Dokumentacja Adtraction: https://adtraction.com/server2server.htm?tp=1333495416
   Paytree = "Paytree", // Partner wewnętrzny
   PaytreeSocialMedia = "PaytreeSocialMedia", // Partner wewnętrzny - social media
   SM = "SM", // Partner wewnętrzny
   CF = "CF", // Partner Cross Finance
   YouMoney = "YouMoney", // Partner YouMoney
   Loando = "Loando", //Partner Loando
   YouAff = "YouAff", //Partner YouAff
   Finperial = "Finperial", // Partner Finperial
   Autopay = "Autopay", //Partner Autopay
   eHelikon = "eHelikon", // Partner eHelikon
}

export enum affiliateAlternativeOffertsNames {
   SHORT_PERIOD_LOAN = "short_period_loan",
}

/**
 * Obiekt zawierający UNIKALNE nazwy parametrów dla każdego z partnerów afiliacyjnych.
 * Aby mechanizm afiliacji poprawnie rozpoznawał linki od konkrentych partnerów
 * CO NAJMNIEJ JEDEN PARAMETR W KAŻDEJ TABLICY MUSI BYĆ UNIKALNY 
 */
export const affiliatePartnersQueryParams = {
   [affiliatePartnersNames.Adtraction]: [
      "utm_source", "at_gd"
   ],

   [affiliatePartnersNames.Paytree]: [
      "utm_source", "paytree_campaign"
   ],

   [affiliatePartnersNames.PaytreeSocialMedia]: [
      "utm_source", "some_campaign"
   ],

   [affiliatePartnersNames.SM]: [
      "utm_source", "sm_campaign"
   ],

   [affiliatePartnersNames.CF]: [
      "utm_source", "cf_campaign"
   ],

   [affiliatePartnersNames.YouMoney]: [
      "utm_source", "ym_campaign", "click_id"
   ],

   [affiliatePartnersNames.Loando]: [
      "utm_source", "loando_campaign", "click_id"
   ],

   [affiliatePartnersNames.YouAff]: [
      "utm_source", "ya_campaign", "click_id"
   ],
   [affiliatePartnersNames.Finperial]: [
      "utm_source", "fp_campaign", "click_id"
   ],
   [affiliatePartnersNames.Autopay]: [
      "utm_source", "autopay_campaign", "click_id"
   ],
   [affiliatePartnersNames.eHelikon]: [
      "utm_source", "he_campaign", "click_id"
   ],
}

/**
 * Czy query string zawiera komplet param  któregoś afiliacyjnego.
 *`utm_source` i `paytree_campaign`
 */
export const hasRecognizedAffiliatePartnerParams = (search: string): boolean => {
   const queryParams = new URLSearchParams(search)

   return Object.values(affiliatePartnersQueryParams).some(partnerParams =>
      partnerParams.every(partnerParam => queryParams.has(partnerParam))
   )
}

export const requestedSteps: SliderStep[] = [
   {from: 0, value: 50},
   {from: 10000, value: 100},
   {from: 15000, value: 500}
]


export const PREDEFINED_PERIODS_EXCLUDED_PARTNERS: affiliatePartnersNames[] = [
   affiliatePartnersNames.Adtraction, affiliatePartnersNames.CF, affiliatePartnersNames.YouMoney, affiliatePartnersNames.Loando,
   affiliatePartnersNames.YouAff, affiliatePartnersNames.Finperial, affiliatePartnersNames.eHelikon
]


/**
 * [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI
 * Funkcja inicjująca mechanizm predefiniowanych okresów pożyczki
 * @param dispatch 
 * @param affiliatePartnerId 
 */
export const enablePredefinedPeriodsLogicForAffiliatePartner = (dispatch: AppDispatch, affiliatePartnerId: affiliatePartnersNames | null): boolean => {
   const isPredefinedPeriodsAvailable = affiliatePartnerId === null || !PREDEFINED_PERIODS_EXCLUDED_PARTNERS.includes(affiliatePartnerId)

   if(isPredefinedPeriodsAvailable) {
      dispatch({
         type: SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
         payload: PREDEFINED_PERIODS_OFFER_LOGIC.LONG_PERIOD
      })

      dispatch({
         type: SET_IS_PREDEFINED_PERIODS_AVAILABLE,
         payload: true
      })
   }

   return isPredefinedPeriodsAvailable
}



export const affiliateAlternativeOffert = {
   [affiliateAlternativeOffertsNames.SHORT_PERIOD_LOAN]: { // Pożyczka na 12 miesięcy
      name: affiliateAlternativeOffertsNames.SHORT_PERIOD_LOAN,
      defaultLoanAmount: 8000,
      defaultInstalments: 12,
      loanParams: {
         maxInstalments: 12,
         minInstalments: 12,
         minRequestedAmount: 1000,
         maxRequestedAmount: 15000,
         requestedAmountSteps: requestedSteps
      } as ILoanInitLimits
   },
}